import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
  production: false,
  language: "sl",  
  wgProfileHost: "https://polnilnice2-api.borzen.si",
  wgPlatformHost: "",

  loginComponent: LoginComponent,
  projIcon: "/assets/project-custom/images/borzen_logo_new.png",
  sidebarIcon: "/assets/project-custom/images/borzen_logo_new.png",
  projectCode: "BORZEN_EV",
  projectName: "",
  locale: 'sl-SI',
  useRouteAndMasterpageCache: true,
  ADLoginEnabled: false,
  dateFormat: 'DD.MM.YYYY',
  navigateAwayPopupEnabled: true,
  useEtag: true,
  newRegistrationLinkDocument: "",
  maxChunkNumber: 40,
  maxFileSizeInMb: 5,
  maxRecordNumberPerPageListing: 30,
  cacheEnabled: false,
  version: '1.1.0',
  showOnlyUserInHeader: true,
  googleClientId: "344277045222-vogtm057h6atno4vrv40od9edd0drbnb.apps.googleusercontent.com",
  useOldSearchViewFeature: false,
  usernameAlwaysToLower: true, // need this shit for EVOZILA1
  useInlineSearch: false,
  maxFileSizeInMbInMessenger: 10,
  projectSidebarName: ""
};

